module.exports = __webpack_public_path__ + "assets/img/star_sentence8.292cc615.png";